const styles = (theme) => ({
  body: {
    marginTop: theme.spacing.unit * 5,
  },
  negativeTopMargin: {
    // Use negative margin to counter-act the displacement caused by the avatar
    [theme.breakpoints.up('md')]: {
      marginTop: '-30px',
    },
  },
});

export default styles;
